import React from "react";
import ReactDOM from "react-dom";

import CookieConsentBanner from "../components/cookie_consent_banner/cookie_consent_banner";

const CONTAINERID = "js-cookie-consent";
const PREFSLINKID = "js-cookie-prefs";

function render() {
  const container = document.getElementById(CONTAINERID);
  const dataset = container.dataset
  const prefsLink = document.getElementById(PREFSLINKID)

  if (container) {
    const COOKIENAMES = {
      perm: "permConsent",
      sess: "sessConsent"
    }

    prefsLink.addEventListener("click", e => {
      e.preventDefault()

      const banner = container.querySelector("[hidden]")

      if (banner) {
        banner.removeAttribute("hidden")
      }
    })

    ReactDOM.render(
      <CookieConsentBanner
        permCookieName={COOKIENAMES.perm}
        sessCookieName={COOKIENAMES.sess}
        consentStatement={dataset.consentStatement}
      />,
      container
    );
  }
}

export default render;



// WEBPACK FOOTER //
// ./controllers/CookieConsent.jsx